<template lang="pug">
  div(v-if="user").wrap-edit-profile.px16.py30
    div.f.fc.mb28
      ItemProfileMediaUploader(
        ref="imageUploader"
        :existingImg="user.photoURL"
        :imgId="uid")
    v-text-field(
      label="名前"
      placeholder="名前を入力"
      v-model="name")
    v-textarea(
      label="プロフィール"
      placeholder="プロフィールを入力"
      v-model="profile")
    div.f.fc
      v-btn(@click="saveProfile" color="#2a2a2a" dark) 保存
</template>

<style lang="scss" scoped>
.wrap-edit-profile {
  width: 100%;
  background: #fff;
}
</style>

<script>
import db from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")
import ItemProfileMediaUploader from "@/components/item/ItemProfileMediaUploader"

export default {
  components: {
    ItemProfileMediaUploader
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  data () {
    return {
      user: null,
      name: "",
      profile: "",
      userType: ""
    }
  },
  async created () {
    var trainerDoc = await db.collection("TRAINER")
      .doc(this.uid)
      .get()
      .then(d => { return d })
    
    if (trainerDoc.exists) {
      this.user = trainerDoc.data()
      this.userType = "trainer"
    } else {
      this.user = await db.collection("TRAINEE")
        .doc(this.uid)
        .get()
        .then(d => { return d.data() })
      this.userType = "trainee"
    }

    this.name = this.user.name
    this.profile = this.user.profile
  },
  methods: {
    async saveProfile () {
      if (this.profile === "") {
        alert("プロフィールを入力してください。")
        return true
      }
      const url = this.$refs.imageUploader.getImgUrl()
      const collection = (this.userType === "trainer") ? "TRAINER" : "TRAINEE"
      await db.collection(collection)
        .doc(this.uid)
        .update({
          name: this.name,
          profile: this.profile,
          photoURL: url,
        })
      alert("保存しました。")
      this.$emit("closeModal")
    }
  }
}
</script>
